import BunkeyAPI from "../api/BunkeyAPI";
import {
  GROUP_BY_CLIENT,
  GROUP_BY_CLIENT_SUCCESS,
  GROUP_BY_CLIENT_FAILURE,
  GROUP_BY_CLIENT_USER_ID,
  GROUP_BY_CLIENT_USER_ID_SUCCESS,
  GROUP_BY_CLIENT_USER_ID_FAILURE,
  GROUP_DETAIL,
  GROUP_DETAIL_SUCCESS,
  GROUP_DETAIL_FAILURE,
  GROUP_CREATE,
  GROUP_CREATE_SUCCESS,
  GROUP_CREATE_FAILURE,
  GROUP_DELETE,
  GROUP_DELETE_SUCCESS,
  GROUP_DELETE_FAILURE,
  GROUP_ADD_OBJECT,
  GROUP_ADD_OBJECT_FAILURE,
  GROUP_REMOVE_OBJECT,
  GROUP_REMOVE_OBJECT_FAILURE,
  GROUP_UPDATE,
  GROUP_UPDATE_SUCCESS,
  GROUP_UPDATE_FAILURE,
  GROUP_APPROVED_REJECTED,
  GROUP_APPROVED_REJECTED_SUCCESS,
  GROUP_APPROVED_REJECTED_FAILURE,
  EDIT_ADMIN_GROUP,
  GET_DEFAULT_PERMISSIONS,
  GET_DEFAULT_PERMISSIONS_SUCCESS,
  GET_DEFAULT_PERMISSIONS_FAILURE
} from "../constants/group-types";
import store from "../store";
import { sendNotification } from "../utils";
import { getNotifications } from "./NotificationAction";
import { setItem, hidePermission } from "./PermissionAction";

/**
 * Creación de grupo
 * @param {*} name
 * @param {*} description
 * @param {*} workclient
 * @param {*} users
 * @param {*} objects
 * @param {*} permissions
 */

export const createGroup = (
  name,
  description,
  workclient,
  users,
  objects,
  permissions,
  lastLevelObjects,
  objectsFilterId,
  allowToReceiveEmail,
  intl
) => {
  return dispatch => {
    dispatch({ type: GROUP_CREATE });
    BunkeyAPI({
      url: `/groups`,
      method: "POST",
      data: {
        name,
        description,
        client: workclient,
        users,
        permissions,
        objects,
        lastLevelObjects,
        objectsFilterId,
        allowToReceiveEmail
      }
    })
      .then(resp => {
        if (resp.status === 200) {
          const message = intl
            .formatMessage({ id: "group_created_success" })
            .replace("#groupname#", resp.data.group.name);
          dispatch({ type: GROUP_CREATE_SUCCESS });
          dispatch(getGroupByClient(workclient));
          sendNotification("success", intl, message, null);
        }
      })
      .catch(err => {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "group_created_failure" })
        );
        dispatch({ type: GROUP_CREATE_FAILURE });
      });
  };
};

/**
 * Actualiza grupo por id
 * @param {*} groupId
 * @param {*} description
 * @param {*} name
 * @param {*} permissions
 */
export const updateGroupById = (
  groupId,
  description,
  name,
  permissions,
  users,
  objects,
  lastLevelObjects,
  objectsFilterId,
  allowToReceiveEmail,
  intl,
  userCreator
) => {
  const workclient = store.getState().client.workclient;

  return dispatch => {
    dispatch({ type: GROUP_UPDATE });
    BunkeyAPI({
      url: `/groups/${groupId}`,
      method: "PUT",
      data: {
        description,
        name,
        permissions,
        users,
        ...(objects !== undefined && { objects }),
        ...(lastLevelObjects !== undefined && { lastLevelObjects }),
        ...(objectsFilterId !== undefined && { objectsFilterId }),
        allowToReceiveEmail,
        userCreator: userCreator
          ? {
              id: userCreator._id,
              name: userCreator.name,
              email: userCreator.email
            }
          : ""
      }
    })
      .then(resp => {
        if (resp.status === 200) {
          dispatch({ type: GROUP_UPDATE_SUCCESS, payload: resp });
          dispatch(getGroupByClient(workclient));
          // KAN-25: si el payload no trae group, no reventar el flujo de éxito
          const groupName =
            resp.data && resp.data.group && resp.data.group.name
              ? resp.data.group.name
              : name;
          const message = intl
            .formatMessage({ id: "group_update_success" })
            .replace("#groupname#", groupName);
          sendNotification("success", intl, message, null);
        } else {
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "group_update_failure" })
          );
          dispatch({ type: GROUP_UPDATE_FAILURE });
        }
      })
      .catch(err => {
        // KAN-25: el error era silencioso y el modal quedaba abierto sin feedback
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "group_update_failure" })
        );
        dispatch({
          type: GROUP_UPDATE_FAILURE
        });
      });
  };
};
/**
 * Agrega un objeto a un grupo
 * @param {*} objectId
 * @param {*} groupId
 */
export const addObjectoToGroup = (objectId, groupId, intl) => {
  const workclient = store.getState().client.workclient;

  return dispatch => {
    dispatch({ type: GROUP_ADD_OBJECT });
    BunkeyAPI({
      url: `/groups/object/${objectId}/group/${groupId}`,
      method: "POST"
    })
      .then(resp => {
        if (resp.status === 200) {
          dispatch(getGroupByClient(workclient));
          dispatch(getGroupByClientIdUserId(workclient));
          sendNotification(
            "process",
            intl,
            intl.formatMessage({ id: "asociate_content" }),
            null,
            "topRight",
            `${intl.formatMessage({ id: "in_process" })}...`,
            `step_one_${resp.data._id}`
          );
        } else {
          dispatch({ type: GROUP_ADD_OBJECT_FAILURE });
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "error_associating_group" })
          );
        }
      })
      .catch(err => {
        dispatch({ type: GROUP_ADD_OBJECT_FAILURE });
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "error_associating_group" })
        );
      });
  };
};

/**
 * Remueve objeto de grupo
 * @param {*} objectId
 * @param {*} groupId
 */
export const removeObjectFromGroup = (objectId, groupId, intl) => {
  const workclient = store.getState().client.workclient;

  return dispatch => {
    dispatch({ type: GROUP_REMOVE_OBJECT });
    BunkeyAPI({
      url: `/groups/object/${objectId}/group/${groupId}`,
      method: "DELETE"
    })
      .then(resp => {
        if (resp.status === 200) {
          dispatch(getGroupByClient(workclient));
          dispatch(getGroupByClientIdUserId(workclient));
          dispatch(hidePermission());
          sendNotification(
            "process",
            intl,
            intl.formatMessage({ id: "remove_object" }),
            null,
            "topRight",
            `${intl.formatMessage({ id: "in_process" })}...`,
            `step_one_${resp.data._id}`
          );
        }
      })
      .catch(err => {
        dispatch({ type: GROUP_REMOVE_OBJECT_FAILURE });
      });
  };
};

/**
 * Obtiene toda la información de un grupo
 * @param {*} groupId
 */
export const getGroupById = groupId => {
  return dispatch => {
    dispatch({ type: GROUP_DETAIL });
    BunkeyAPI({
      url: `/groups/${groupId}`,
      method: "GET"
    })
      .then(resp => {
        if (resp.status === 200) {
          dispatch({
            type: GROUP_DETAIL_SUCCESS,
            payload: resp.data
          });
        }
      })
      .catch(err => {
        dispatch({ type: GROUP_DETAIL_FAILURE });
      });
  };
};

/**
 * Obtiene todos los grupos por cliente
 * @param {*} workclient
 */
export const getGroupByClient = workclient => {
  return async dispatch => {
    dispatch({ type: GROUP_BY_CLIENT });
    try {
      let allGroups = [];
      let page = 1;
      const limit = 50;
      let hasMore = true;

      while (hasMore) {
        const resp = await BunkeyAPI({
          url: `/groups/client/${workclient}?page=${page}&limit=${limit}`,
          method: "GET"
        });
        allGroups = [...allGroups, ...resp.data];
        const total = parseInt(resp.headers['x-pagination-total-count'], 10);
        hasMore = allGroups.length < total;
        page++;
      }

      dispatch({ type: GROUP_BY_CLIENT_SUCCESS, payload: allGroups });
    } catch (err) {
      dispatch({ type: GROUP_BY_CLIENT_FAILURE });
    }
  };
};

/**
 * Obtiene todos los grupos filtrando por el usuario que realiza la petición y el cliente
 * @param {*} workclient
 */
export const getGroupByClientIdUserId = workclient => {
  return (dispatch, getState) => {
    dispatch({ type: GROUP_BY_CLIENT_USER_ID });
    const defaultPermissions = getState().group.defaultPermissions.slice();
    BunkeyAPI({
      url: `/users/me/groups/${workclient}`,
      method: "GET"
    })
      .then(resp => {
        dispatch({
          type: GROUP_BY_CLIENT_USER_ID_SUCCESS,
          payload: {
            data: resp.data,
            permissionDefault: defaultPermissions
          }
        });
      })
      .catch(err => {
        dispatch({ type: GROUP_BY_CLIENT_USER_ID_FAILURE });
      });
  };
};

/**
 * Elimina grupo por id
 * @param {*} groupId
 */
export const deleteGroupById = (groupId, intl) => {
  const item = store.getState().permission.item;
  return dispatch => {
    dispatch({ type: GROUP_DELETE });
    BunkeyAPI({
      url: `/groups/${groupId}`,
      method: "DELETE"
    })
      .then(resp => {
        if (resp.status === 200) {
          sendNotification(
            "success",
            intl,
            intl.formatMessage({ id: "group_successfully_removed" })
          );
          dispatch({ type: GROUP_DELETE_SUCCESS });
          if (item && item.group) {
            dispatch(
              setItem({
                ...item,
                group: item.group.filter(r => r._id !== groupId)
              })
            );
          }
        } else {
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "error_deleting_group" })
          );
          dispatch({ type: GROUP_DELETE_FAILURE });
        }
      })
      .catch(err => {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "error_deleting_group" })
        );
        dispatch({ type: GROUP_DELETE_FAILURE });
      });
  };
};

/**
 * Aprueba o rechaza una solicitud de permiso
 * @param {*} requestId
 * @param {*} status
 */
export const approvedRejectedUserRequest = (
  requestId,
  status,
  intl,
  sendEmail
) => {
  return dispatch => {
    dispatch({ type: GROUP_APPROVED_REJECTED });
    BunkeyAPI({
      url: `/groups/updateRequestPermissionStatus/${requestId}`,
      method: "POST",
      data: {
        status,
        sendEmail
      }
    })
      .then(resp => {
        if (resp.status === 200 && resp.data.value === "success") {
          const workclient = store.getState().client.workclient;
          dispatch(getNotifications(workclient, intl));
          dispatch({ type: GROUP_APPROVED_REJECTED_SUCCESS });
        } else {
          dispatch({ type: GROUP_APPROVED_REJECTED_FAILURE });
        }
      })
      .catch(err => {
        dispatch({ type: GROUP_APPROVED_REJECTED_FAILURE });
      });
  };
};

// Permite ocultar el boton de editar administrador en un grupo , recibe el id del grupo y true o false si cambia el admin

export const editAdminGroup = (id, clickButton) => {
  return dispatch => {
    dispatch({
      type: EDIT_ADMIN_GROUP,
      payload: {
        idGroup: id,
        updateAdmiGroup: clickButton
      }
    });
  };
};

export const setDefaultPermissionsSuccess = permissions => {
  return {
    type: GET_DEFAULT_PERMISSIONS_SUCCESS,
    payload: permissions
  };
};

export const setDefaultPermissionsFailure = () => {
  return {
    type: GET_DEFAULT_PERMISSIONS_FAILURE,
    payload: []
  };
};
export const getDefaultPermissions = () => {
  return dispatch => {
    dispatch({ type: GET_DEFAULT_PERMISSIONS });
    BunkeyAPI({
      url: `/clients/getGlobalAccess`,
      method: "GET"
    })
      .then(resp => {
        if (resp.status === 200) {
          dispatch(setDefaultPermissionsSuccess(resp.data));
        }
      })
      .catch(err => {
        dispatch(setDefaultPermissionsFailure());
      });
  };
};
